import { MalwarebytesProtectionStatus } from '@electricjs/core_entity-client';

export type AddOnInterestEmailArgs = {
  organizationId: string;
  addOn: string;
};

export type LearnMoreAboutSecurityEmailArgs = {
  organizationId: string;
  securityType: string;
};

export const AddOnVendors = {
  ThreatDown: 'threatdown',
  CheckPointHarmonySASE: 'checkpoint-harmony-sase',
  CheckPointHarmonyEC: 'checkpoint-harmony-ec',
  Keeper: 'keeper',
  Fullsteam: 'fullsteam',
  BreachSecureNow: 'breachsecurenow',
  Dropsuite: 'dropsuite',
  Drata: 'drata',
} as const;

export type AddOnVendor = (typeof AddOnVendors)[keyof typeof AddOnVendors];

export const AddOnVendorNames: Partial<Record<AddOnVendor, string>> = {
  [AddOnVendors.CheckPointHarmonyEC]: 'Check Point',
} as const;

// NERV-4535: Addon names enum to filter out by name
export const AddOnNames = {
  Warehousing: 'Warehousing',
} as const;

export const ISVVendorsByLegacyName = {
  Malwarebytes: 'Malwarebytes',
  Perimeter81: 'Perimeter81',
  Avanan: 'Avanan',
} as const;

// the vendors for addOns from the api response are not consistent with the keys in AddOnVendors
export const apiVendorMap: Record<string, AddOnVendor> = {
  [ISVVendorsByLegacyName.Malwarebytes]: AddOnVendors.ThreatDown,
  // TODO: Remove Perimeter81 once backend is updated - ARCH-2436
  [ISVVendorsByLegacyName.Perimeter81]: AddOnVendors.CheckPointHarmonySASE,
  CheckPointHarmonySASE: AddOnVendors.CheckPointHarmonySASE,
  // TODO: Remove Avanan once backend is updated - ARCH-2436
  [ISVVendorsByLegacyName.Avanan]: AddOnVendors.CheckPointHarmonyEC,
  [AddOnVendorNames[AddOnVendors.CheckPointHarmonyEC] as string]:
    AddOnVendors.CheckPointHarmonyEC,
  Keeper: AddOnVendors.Keeper,
  'Breach Secure Now': AddOnVendors.BreachSecureNow,
  Dropsuite: AddOnVendors.Dropsuite,
};

export type SecuritySolutionsVendor = Extract<
  AddOnVendor,
  | typeof AddOnVendors.ThreatDown
  | typeof AddOnVendors.CheckPointHarmonySASE
  | typeof AddOnVendors.CheckPointHarmonyEC
>;

export type AddOn = {
  id: string;
  name: string;
  vendor: string;
  sku: string;
};

export type AddOrganizationAddOnArgs = {
  addOnId: string;
  licenseCount: number;
};

export type UpdateOrganizationAddOnArgs = {
  organizationId: string;
  addOnId: string;
  licenseCount: number;
};

export type RemoveOrganizationAddOnArgs = {
  organizationId: string;
  addOnId: string;
};

export type ThreatDownOverview = {
  blockedThreatsCount: number;
  machinesRegisteredCount: number;
  devicesRestoredCleanedCount: number;
  devicesScannedCount: number;
};

export type ThreatDownDeviceInfo = {
  employeeFirstName?: string;
  employeeLastName?: string;
  deviceHardwareModel?: string;
  deviceSerialNumber?: string;
  deviceHostname?: string;
  protectionStatus: MalwarebytesProtectionStatus | string;
  requiresReboot: boolean;
  groupPolicyName?: string;
  lastSeenAt?: string;
  lastScannedAt?: string;
  assetId?: string;
  employeeId?: string;
};
